import React, { useContext, useEffect, useState } from "react"
import { Context } from "./../../../context/app-context"
import {
  activitySEO,
  pointsByMatch,
  delayFlip,
  competitionId,
  timeForLevels
} from "./../../../constants/activity-constants"
import gameServices from "./../../../services/game-service"

import sessionStorage from "./../../../utils/sessionStorage"
import useInterval from "./../../../utils/useInterval"
import logoCampana from "./../../../assets/images/logoCampana.png"

import GridCard from "./../../molecules/grid-card/grid-card"
import logo from "../../../assets/images/logoCampana.png"

import "./game.scss"

export default function Game() {
  const [session] = useState(new sessionStorage())
  const { dispatch, modalActive, tokenParticipation } = useContext(Context)
  const [level, setLevel] = useState(0)
  const [points, setPoints] = useState(0)
  const [totalPoints, setTotalPoints] = useState(0)
  const [time, setTime] = useState(timeForLevels[0])
  const [timerIsRunning, setTimerIsRunning] = useState(false)
  const [orderModalEducational, setOrderModalEducational] = useState([])

  const handleStart = () => {
    setLevel(1)
    setTimerIsRunning(true)
  }
  const handleEndgame = () => {
    setTimerIsRunning(false)
    dispatch({
      type: "set-context",
      payload: {
        modalActive: {
          type: "loading",
          handleClose: () => {
            // window.location.href = `${activitySEO.url}/`
          },
          props: { noClose: true }
        }
      }
    })

    // TODO: Redimir tokenParticipationService() => hanldedispatch modal pointsByMatch
    let payload = {
      point: totalPoints,
      tokenGame: tokenParticipation,
      gameId: competitionId
    }
    var config = {
      headers: {
        Authorization: session.getToken().idToken
      }
    }
    gameServices
      .postGameParticipationSave(payload, config)
      .then(res => {
        if (res.status === 200) {
          dispatch({
            type: "set-context",
            payload: {
              modalActive: {
                type: "endGame",
                props: {
                  totalPoints,
                  handleSuccess: () => {
                    handleRestart()
                  }
                },
                handleClose: () => {
                  window.location.href = `${activitySEO.url}/`
                }
              }
            }
          })
        } else {
          window.location.reload(false)
        }
      })
      .catch(e => {
        console.log(e)
        window.location.href = `${activitySEO.url}/`
      })
  }

  const handleRestart = () => {
    window.location.reload(false)
  }

  useEffect(() => {
    let order = [0, 1, 2, 3, 4]
    order = order.sort(function() {
      return Math.random() - 0.5
    })
    setOrderModalEducational(order)
  }, [])

  // Cronometer
  useInterval(
    () => {
      setTime(time - 1)
    },
    timerIsRunning ? 1000 : null
  )

  useEffect(() => {
    if (time < 1) {
      handleEndgame()
    }
  }, [time])

  const restoreTimeForLevel = () => {
    if (level !== 5) {
      setTimerIsRunning(true)
      setTime(timeForLevels[level])
    }
  }

  const viewModalInfo = (__modalView, __handleClose) => {
    dispatch({
      type: "set-context",
      payload: {
        modalActive: {
          type: "educational",
          handleClose: () => {
            __handleClose()
            restoreTimeForLevel()
          },
          props: {
            modalView: __modalView,
            handleNext: () => {
              dispatch({
                type: "set-context",
                payload: {
                  modalActive: null
                }
              })
              __handleClose()
              restoreTimeForLevel()
            }
          }
        }
      }
    })
  }

  useEffect(() => {
    if (session.getToken() !== null) {
      if (!tokenParticipation) {
        dispatch({
          type: "set-context",
          payload: {
            modalActive: {
              type: "redemption",
              handleClose: () => {
                window.location.href = `${activitySEO.url}/`
              }
            }
          }
        })
      } else {
        dispatch({
          type: "set-context",
          payload: {
            modalActive: null
          }
        })
      }
    } else {
      dispatch({
        type: "set-context",
        payload: {
          modalActive: {
            type: "unauthenticated",
            handleClose: () => {
              window.location.href = `${activitySEO.url}/`
            }
          }
        }
      })
    }
  }, [session, dispatch, tokenParticipation])

  useEffect(() => {
    if (points !== 0) setTotalPoints(totalPoints + pointsByMatch)
    if (points >= pointsByMatch + pointsByMatch * level) {
      if (level <= 5) {
        setTimerIsRunning(false)
        let modalView = orderModalEducational[level - 1]
        const nextLevel = () => {
          setLevel(level + 1)
          setPoints(0)
        }
        if (level !== 5) {
          viewModalInfo(modalView, nextLevel)
        } else {
          viewModalInfo(modalView, handleEndgame)
        }
        // setTimeout(() => {
        //   setLevel(level + 1)
        //   setPoints(0)
        // }, delayFlip)
      }
      // else {
      //   handleEndgame()
      // }
    }
  }, [points])

  // TODO: moment transform timer
  // const currentTime = moment(
  //   moment
  //     .duration({
  //       milliseconds: timer
  //     })
  //     .as("millisecond")
  // ).format("mm:ss")

  return (
    <div className="game">
      <div className="game__container">
        <section className="game__container__panel">
          <div className="panel-wrapper">
            {[
              // TODO: userMoment { label: "Tiempo", value: "1:00" },
              { label: "Tiempo", value: time },
              { label: "Puntos", value: totalPoints },
              { label: "Nivel", value: level }
            ].map((item, index) => {
              return (
                <p className="panel-item" key={index}>
                  <span className="item-value">{item.value}</span>
                  <span className="item-label">{item.label}</span>
                </p>
              )
            })}
          </div>
        </section>
        <section className="game__container__body">
          {level < 1 && !modalActive && (
            <div className="popup">
              <div className="popup__wrapper">
                <h3 className="family-H-Bold color-blue textBienvenida">Bienvenida a</h3>
                <img
                  className="logoCampana"
                  src={logoCampana}
                  alt="campana logo"
                />
                <p className="family-H-Medium color-blue">
                  Demuestra que eres una experta <br /> memorizando y
                  encontrando todas <br />
                  las parejas del Poder de la Zona V. <br /> <br />{" "}
                  <span className="family-H-Bold color-blue">
                    ¡Corre! Tienes poco tiempo.
                  </span>
                </p>
                <button
                  className="btn-primary f-concentrate-game-btn"
                  onClick={handleStart}
                >
                  JUGAR
                </button>
              </div>
            </div>
          )}
          <GridCard level={level} points={points} setPoints={setPoints} />

          <div className="game__container__logo-mob">
            <img src={logo} alt="V-Match" />
          </div>
        </section>
      </div>
    </div>
  )
}
